import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  FlexBoxJustifyContent,
  FlexBoxAlignItems,
  Title,
  ObjectPage,
  ObjectPageSection,
  ObjectPageHeader,
  ObjectPageTitle,
  ObjectStatus,
  Label,
  FlexBox,
  Button,
  AnalyticalTable,
  Text,
  BusyIndicator,
  Dialog,
  Select,
  Option,
  Icon
} from '@ui5/webcomponents-react';
import Breadcrumbs from './Breadcrumbs';
import axiosInstance from '../utils/axiosInstance';
import Navbar from './Navbar';
import SideMenu from './SideMenu';
import usePermission from '../hooks/usePermission';
import { parseToNumber, formatNumberWithComma, formatDateToDDMMYYYY, rightAlignedNumberStyle, getStatusStyle, getStatusComponentProps, formatCurrency } from '../utils/validator';
import useAutoTranslate from '../hooks/useAutoTranslate';

const ASNDetail = () => {
  const { id } = useParams();
  const [asnDetail, setAsnDetail] = useState(null);
  const [purchaseOrder, setPurchaseOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState(0);
  const [error, setError] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const navigate = useNavigate();
  const [activePart, setActivePart] = useState('');
  const [activeTab, setActiveTab] = useState('ASNs');
  const [printDialogOpen, setPrintDialogOpen] = useState(false);
  const [bultoMateriales, setBultoMateriales] = useState([]);
  const [rejectionReason, setRejectionReason] = useState('');
  const fileInputRef = useRef(null);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [showStatusDialog, setShowStatusDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [newStatus, setNewStatus] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showTrackingModal, setShowTrackingModal] = useState(false);
  const [trackingInfo, setTrackingInfo] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const { hasPermission } = usePermission();
  const { autoT, i18n } = useAutoTranslate();

  // Función para verificar si el usuario es un proveedor
  const isProviderUser = () => {
    try {
      const userDataString = localStorage.getItem('userData');
      if (!userDataString) return false;

      const userData = JSON.parse(userDataString);
      console.log("User Data1:", userData?.companyTypeName);
      console.log("User Data2:", userData?.role?.roleName);
      return  userData?.role?.roleName === 'PROVEEDOR';
    } catch (error) {
      console.error(autoT('Error al verificar rol de usuario:'), error);
      return false;
    }
  };

  const statusOptions = [
    { value: 'all', label: autoT('Todos') },
    { value: 'Approved', label: autoT('Finalizado') },
    { value: 'Shipped', label: autoT('Despachada') },
    { value: 'Pending', label: autoT('Creada') },
    { value: 'Default', label: autoT('Por Despachar') },
    { value: 'Received', label: autoT('Recepcionada') },
    { value: 'Canceled', label: autoT('Anulada') },
    { value: 'Shipment', label: autoT('Preparando envio') },
    { value: 'In transit', label: autoT('En camino') },
    { value: 'Delivered', label: autoT('Entregado') },
    { value: 'Returned', label: autoT('Devuelto') },
    { value: 'Modified', label: autoT('Modificado') }
  ];

  const materialColumns = [
    { Header: autoT('Posición OC'), accessor: 'lineId' },
    { Header: autoT('Código de material'), accessor: 'materialCode' },
    { Header: autoT('Material'), accessor: 'description' },
    { 
        Header: autoT('Cantidad'), 
        accessor: 'quantity', 
        width: 100, 
        Cell: ({ value }) => (
          <Text style={rightAlignedNumberStyle()}>{formatNumberWithComma(value)}</Text>
        )
    },
    { Header: autoT('Unidad'), accessor: 'unit' },
    {
        Header: autoT('Precio Unitario'),
        accessor: 'pricePerUnit',
        Cell: ({ value }) => (
          <Text style={rightAlignedNumberStyle()}>{formatCurrency(value, purchaseOrder?.currency)}</Text>
        )
    },
    {
        Header: autoT('Precio Total'),
        accessor: 'totalPrice',
        Cell: ({ value }) => (
          <Text style={rightAlignedNumberStyle()}>{formatCurrency(value, purchaseOrder?.currency)}</Text>
        )
    },
    {
        Header: autoT('Moneda'),
        id: 'currency',
        Cell: () => <Text>{purchaseOrder?.currency || ''}</Text>
    },
    { 
        Header: autoT('Posición Notificación'), 
        accessor: (row, rowIndex) => rowIndex + 1 
    },
  ];

  const dialogStatusOptions = [
    { value: 'Shipped', label: autoT('Despachar') },
    { value: 'Canceled', label: autoT('Anular') }
  ];
  
  const dialogStatusOptions2 = [
    { value: 'Received', label: autoT('Recepcionada') },
    { value: 'Pending', label: autoT('Volver a Creada') }
  ];
  
  const dialogStatusOptions3 = [
    { value: 'Delivered', label: autoT('Entregado') },
    { value: 'Returned', label: autoT('Devuelto') }
  ];
  
  const dialogStatusOptions4 = [
    { value: 'Approved', label: autoT('Finalizar') },
    { value: 'Returned', label: autoT('Devuelto') }
  ];

  // Función para obtener las opciones de estado disponibles según el rol y estado actual
  const getAvailableStatusOptions = () => {
    const isProvider = isProviderUser();
    console.log("ASN Status:", asnDetail?.asnStatus);
    console.log("Is Provider User:", isProviderUser());
    if (asnDetail?.asnStatus === 'Shipped') {
      return isProvider ? 
        dialogStatusOptions2.filter(option => option.value === 'Pending') :
        dialogStatusOptions2;
    } else if (asnDetail?.asnStatus === 'In transit') {
      return dialogStatusOptions3;
    } else if (asnDetail?.asnStatus === 'Delivered') {
      return dialogStatusOptions4;
    } else {
      return dialogStatusOptions;
    }
  };

  let optionsToShow = getAvailableStatusOptions();

  const historicData = [
    {
      asnNumber: '310000315',
      amount: '2.000',
      description: autoT('Notificación para la orden de compra {{orderNumber}}', { orderNumber: id }),
      date: '3 de febrero de 2022',
      status: autoT('Enviado')
    },
    {
      asnNumber: '310000313',
      amount: '3.000',
      description: autoT('Notificación para la orden de compra {{orderNumber}}', { orderNumber: id }),
      date: '3 de febrero de 2022',
      status: autoT('Enviado')
    }
  ];

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedRow(null);
  };

  const handleDialogAsnPrint = async () => {
    if (!asnDetail?.id) {
      console.error(autoT('No se encontró ID de ASN para imprimir'));
      return;
    }

    // Verificar si el usuario tiene permisos para imprimir notificaciones
    if (!hasPermission('notification', 'listView')) {
      console.error(autoT('Usuario sin permisos para imprimir notificaciones'));
      return;
    }

    try {
      console.log(autoT('Verificando existencia del PDF para ASN:'), asnDetail.asnNumber);
      
      // Obtener el token del localStorage
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error(autoT('No se encontró el token de autenticación'));
      }

      // Construir la URL base correctamente
      const baseUrl = process.env.REACT_APP_API_URL || 'https://localhost:8443/api/v1';

      // Primero verificar si el PDF existe
      const verifyUrl = `${baseUrl}/blob/asn-documents/verify/${asnDetail.asnNumber}`.replace(/([^:]\/)\/+/g, "$1");
      
      console.log(autoT('Verificando PDF en:'), verifyUrl);
      
      const verifyResponse = await fetch(verifyUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Origin': window.location.origin
        },
        credentials: 'include',
        mode: 'cors'
      });

      if (!verifyResponse.ok) {
        throw new Error(autoT('Error al verificar el PDF: {{status}} {{statusText}}', { 
          status: verifyResponse.status, 
          statusText: verifyResponse.statusText 
        }));
      }

      // Proceder con la descarga
      const downloadUrl = `${baseUrl}/blob/asn-documents/download/${asnDetail.asnNumber}`.replace(/([^:]\/)\/+/g, "$1");
      
      console.log(autoT('Descargando PDF desde:'), downloadUrl);
      
      const response = await fetch(downloadUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/pdf',
          'Origin': window.location.origin
        },
        credentials: 'include',
        mode: 'cors'
      });

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error(autoT('Error de autenticación. Por favor, inicie sesión nuevamente.'));
        }
        throw new Error(autoT('Error al descargar el PDF: {{status}} {{statusText}}', { 
          status: response.status, 
          statusText: response.statusText 
        }));
      }

      // Verificar el tipo de contenido
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/pdf')) {
        console.warn(autoT('Tipo de contenido inesperado:'), contentType);
      }

      // Obtener el blob del PDF
      const blob = await response.blob();
      
      if (blob.size === 0) {
        throw new Error(autoT('El PDF descargado está vacío'));
      }

      // Crear URL del blob y descargar
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = `ASN-${asnDetail.asnNumber}.pdf`;
      document.body.appendChild(a);
      a.click();
      
      // Limpieza
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);

      console.log(autoT('PDF descargado exitosamente para ASN: {{asnNumber}}', { asnNumber: asnDetail.asnNumber }));
    } catch (error) {
      console.error(autoT('Error al descargar el PDF:'), error);
      if (error.response) {
        try {
          const errorText = await error.response.text();
          console.error(autoT('Estado de la respuesta:'), error.response.status);
          console.error(autoT('Detalles del error:'), errorText);
        } catch (e) {
          console.error(autoT('No se pudieron obtener detalles adicionales del error'));
        }
      }
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const PurchaseOrderNode = ({ orderNumber }) => (
    <div style={{ 
      backgroundColor: 'white',
      padding: '1rem',
      width: '180px',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      margin: '10px'
    }}>
      <Text style={{ fontWeight: 'bold', fontSize: '1rem' }}>{autoT('Orden de compra')}</Text>
      <Text style={{ color: '#666', fontSize: '0.9rem' }}>#ORD-{orderNumber}</Text>
    </div>
  );

  const AsnNode = ({ number }) => (
    <div style={{ 
      backgroundColor: '#f0fff4',
      padding: '1rem',
      width: '140px',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      margin: '10px'
    }}>
      <Text style={{ fontWeight: 'bold', fontSize: '1rem' }}>{autoT('Notificación')}</Text>
      <Text style={{ color: '#666', fontSize: '0.9rem' }}>#{number}</Text>
    </div>
  );

  const trackingStyles = {
    trackingModal: {
      padding: '1rem',
    },
    trackingStepsContainer: {
      position: 'relative',
    },
    trackingStep: {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: '1.5rem',
    },
    trackingStepBefore: {
      content: '""',
      position: 'absolute',
      left: '1rem',
      top: '2rem',
      bottom: 0,
      width: '1px',
      backgroundColor: '#d1d5db',
      zIndex: 1,
    },
    trackingStepLastBefore: {
      display: 'none',
    },
    trackingIcon: {
      backgroundColor: 'white',
      borderRadius: '50%',
      padding: '0.5rem',
      zIndex: 2,
      position: 'relative',
    },
    trackingDetails: {
      marginLeft: '1rem',
    },
    trackingDetailsH4: {
      fontSize: '1.125rem',
      fontWeight: 600,
      margin: 0,
    },
    trackingDetailsP: {
      margin: 0,
      fontSize: '0.875rem',
      color: '#4b5563',
    },
    trackingDetailsAction: {
      fontWeight: 'bold',
      fontSize: '1rem',
      color: '#374151',
    },
  };

  const PackageNode = ({ number }) => (
    <div style={{ 
      backgroundColor: 'white',
      padding: '0.75rem',
      width: '120px',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      margin: '8px'
    }}>
      <Text style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>{autoT('BULTO NRO')}</Text>
      <Text style={{ fontSize: '0.9rem' }}>{number}</Text>
    </div>
  );

  const handleConfirmPrint = (packageData) => {
    // Verificar si el usuario tiene permisos para imprimir notificaciones
    if (!hasPermission('notification', 'listView')) {
      console.error(autoT('Usuario sin permisos para imprimir paquetes'));
      return;
    }
    
    setSelectedRow(packageData);
    setPrintDialogOpen(true);
  };

  const handlePrint = async (row) => {
    if (!row || !row.id) {
      console.error(autoT('No se encontró ID de ASN para imprimir'));
      return;
    }

    // Verificar si el usuario tiene permisos para imprimir notificaciones
    if (!hasPermission('notification', 'listView')) {
      console.error(autoT('Usuario sin permisos para imprimir paquetes'));
      return;
    }

    try {
      // Primera petición para obtener la URL del PDF
      const response = await axiosInstance.get(
        `asn-documents/getPdf/${row.id}`
      );

      // Obtener la URL del PDF de la respuesta
      const pdfUrl = response.data.asnNumber;
      if (!pdfUrl) {
        console.error(autoT('No se devolvió ninguna URL de PDF del servidor'));
        return;
      }

      // Segunda petición para obtener el PDF como blob
      const pdfResponse = await axiosInstance.get(pdfUrl, {
        responseType: 'blob'
      });

      // Crear y descargar el PDF
      const blob = new Blob([pdfResponse.data], { type: 'application/pdf' });
      const downloadUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = `ASN-${asnDetail.asnNumber}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // Liberar el URL
      URL.revokeObjectURL(downloadUrl);

    } catch (error) {
      console.error(autoT('Error al obtener o descargar el PDF:'), error.message);
    }
  };
  
  const fetchASNDetail = async () => {
    try {
      const response = await axiosInstance.get(`asn-documents/${id}`);
      setAsnDetail(response.data.data);
    } catch (err) {
      setError(autoT('Error al obtener detalles de ASN'));
    } finally {
      setLoading(false);
    }
  };

  const fetchPurchaseOrder = async () => {
    try {
      const response = await axiosInstance.get(`purchase-orders/${asnDetail?.purchaseOrderId}`);
      setPurchaseOrder(response.data.data);
    } catch (err) {
      setError(autoT('Error al obtener Orden de Compra'));
    } finally {
      setLoading(false);
    }
  };

  const fetchAsnTrackingHistory = async () => {
    try {
      const response = await axiosInstance.get(`history/tracking/${id}`);
      
      if (response.data && response.data.data && response.data.data.length > 0) {
        setTrackingInfo(response.data.data);
      } else {
        setTrackingInfo([]);
        console.log(autoT('No hay historial de seguimiento disponible para este ASN.'));
      }
    } catch (err) {
      console.error(autoT('Error al obtener seguimiento de ASN:'), err);
    } finally {
      setLoading(false);
    }
  };

  const fetchAttachments = async () => {
    try {
      const response = await axiosInstance.get(`attachments/asn-document/${id}`);
      
      if (response.data && response.data.data && response.data.data.length > 0) {
        setAttachments(response.data.data);
      } else {
        setAttachments([]);
        console.log(autoT('No hay adjuntos disponibles para este ASN.'));
      }
    } catch (err) {
      console.error(autoT('Error al obtener adjuntos de ASN:'), err);
      setAttachments([]);
    }
  };

  const handleShowTracking = () => {
    if (!hasPermission('notification', 'listView')) {
      console.error(autoT('Usuario sin permisos para ver el seguimiento'));
      return;
    }
    
    fetchAsnTrackingHistory();
    setShowTrackingModal(true);
  }

  useEffect(() => {
    fetchASNDetail();
    fetchAttachments();
  }, [id]);
  
  useEffect(() => {
    if (asnDetail?.purchaseOrderId) {
      fetchPurchaseOrder();
    }
  }, [asnDetail?.purchaseOrderId]);

  const getStatusLabel = (statusValue) => {
    const status = statusOptions.find(opt => opt.value === statusValue);
    return status ? status.label : statusValue;
  };

  const handleStatusUpdate = async () => {
    try {
      console.log(autoT('Iniciando actualización de estado:'), newStatus);
      
      // Validar si el usuario tiene permisos para actualizar notificaciones
      const userDataString = localStorage.getItem('userData');
      const userData = JSON.parse(userDataString);
      
      // Verificar si el usuario es PROVEEDOR o ADMIN
      const isProvider = isProviderUser();
      
      // Si es proveedor y está intentando cambiar a Received, no permitir
      if (isProvider && newStatus === 'Received') {
        setErrorMessage(autoT('Los usuarios con rol PROVEEDOR no pueden cambiar el estado a Recepcionada.'));
        setShowErrorDialog(true);
        setShowStatusDialog(false);
        return;
      }

      console.log(autoT('Enviando solicitud de actualización para ASN:'), asnDetail?.id);
      
      const token = localStorage.getItem('token');
      const modifiedBy = userData.id;
      
      const requestBody = { 
        asnStatus: newStatus, 
        description: newStatus === 'Canceled' ? autoT('ASN Anulada por el usuario por el motivo: {{reason}}', { reason: rejectionReason }) : rejectionReason,
        modifiedBy: modifiedBy
      };

      console.log(autoT('Cuerpo de la solicitud:'), requestBody);
      
      const response = await axiosInstance.put(`/asn-documents/${asnDetail?.id}`, requestBody, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      // Si el nuevo estado es Approved, crear el GRN
      if (newStatus === 'Approved') {
        await createGRN();
      }

      setShowStatusDialog(false);
      setSelectedOrders([]);
      setNewStatus('');
      setRejectionReason('');
      
      // Recargar los detalles del ASN
      await fetchASNDetail();
      
    } catch (error) {
      console.error(autoT('Error al actualizar estados:'), error);
      setErrorMessage(error.response?.data?.message || autoT('Error al actualizar el estado de la notificación.'));
      setShowErrorDialog(true);
    }
  };

  const createGRN = async () => {
    try {
      // Calcular la suma de las cantidades recibidas
      const totalReceivedQuantity = asnDetail?.items.reduce((sum, item) => {
        return sum + (item.quantity || 0);
      }, 0);

      const grnPayload = {
        asnDocumentId: asnDetail?.id,
        grnNumber: Math.floor(100000000 + Math.random() * 900000000).toString(),
        receivedQuantity: totalReceivedQuantity,
        grnStatus: "Completed"
      };

      const response = await axiosInstance.post('/grn', grnPayload);
      console.log(autoT('GRN creado exitosamente:'), response.data);
    } catch (error) {
      console.error(autoT('Error al crear el GRN:'), error);
      throw error;
    }
  };

  const handleShowList = () => {
    navigate('/home', { state: { activePart: 'home' } });
  };

  const renderMapContent = () => (
    <div style={{ 
      width: '100%',
      minHeight: '300px',
      padding: '1rem',
      backgroundColor: 'white',
      position: 'relative'
    }}>
      {/* SVG para las flechas */}
      <svg 
        style={{ 
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none'
        }}
      >
        <defs>
          <marker
            id="arrowhead"
            markerWidth="8"
            markerHeight="6"
            refX="8"
            refY="3"
            orient="auto"
          >
            <polygon points="0 0, 8 3, 0 6" fill="#0066cc" />
          </marker>
        </defs>

        {/* Flechas de OC a ASNs */}
        <path
          d="M 220,80 L 380,50"
          stroke="#0066cc"
          strokeWidth="1.5"
          strokeDasharray="4,4"
          markerEnd="url(#arrowhead)"
        />
        <path
          d="M 220,80 L 380,160"
          stroke="#0066cc"
          strokeWidth="1.5"
          strokeDasharray="4,4"
          markerEnd="url(#arrowhead)"
        />

        {/* Flechas de ASN 2455 a sus Bultos */}
        <path
          d="M 520,50 L 680,30"
          stroke="#0066cc"
          strokeWidth="1.5"
          strokeDasharray="4,4"
          markerEnd="url(#arrowhead)"
        />
        <path
          d="M 520,50 L 680,90"
          stroke="#0066cc"
          strokeWidth="1.5"
          strokeDasharray="4,4"
          markerEnd="url(#arrowhead)"
        />

        {/* Flechas de ASN 2456 a sus Bultos */}
        <path
          d="M 520,160 L 680,150"
          stroke="#0066cc"
          strokeWidth="1.5"
          strokeDasharray="4,4"
          markerEnd="url(#arrowhead)"
        />
        <path
          d="M 520,160 L 680,210"
          stroke="#0066cc"
          strokeWidth="1.5"
          strokeDasharray="4,4"
          markerEnd="url(#arrowhead)"
        />
      </svg>

      {/* Contenido del mapa */}
      <div style={{ 
        display: 'flex',
        justifyContent: 'space-between',
        position: 'relative',
        zIndex: 1,
        padding: '0 20px'
      }}>
        {/* Orden de Compra */}
        <div style={{ width: '200px', marginTop: '40px' }}>
          <PurchaseOrderNode orderNumber={id} />
        </div>

        {/* ASNs */}
        <div style={{ 
          width: '160px',
          display: 'flex',
          flexDirection: 'column',
          gap: '80px'
        }}>
          <AsnNode number="2455" />
          <AsnNode number="2456" />
        </div>

        {/* Bultos */}
        <div style={{ 
          width: '140px',
          display: 'flex',
          flexDirection: 'column',
          gap: '30px'
        }}>
          {/* Bultos del primer ASN */}
          <div style={{ marginBottom: '20px' }}>
            <PackageNode number="355" />
            <PackageNode number="111" />
          </div>
          {/* Bultos del segundo ASN */}
          <div>
            <PackageNode number="34" />
            <PackageNode number="35" />
          </div>
        </div>
      </div>

      <style>
        {`
          @keyframes dash {
            to {
              stroke-dashoffset: 20;
            }
          }
          path {
            animation: dash 1.5s linear infinite;
          }
        `}
      </style>
    </div>
  );

  const handleOpenDetails = (bultoData) => {
    const materialesDelBulto = bultoData.packingLists.map(item => {
      const materialCompleto = asnDetail.items.find(
        material => material.materialCode === item.itemDescription
      );
      
      return {
        materialCode: item.itemDescription,
        description: materialCompleto?.description || '',
        quantity: item.quantity || 0,
        unit: materialCompleto?.unit || ''
      };
    });

    setBultoMateriales(materialesDelBulto);
    setSelectedRow(bultoData);
    setDialogOpen(true);
  };

  // Modificar las columnas de la tabla de bultos
  const packageColumns = [
    { 
      Header: autoT('Número de bulto'), 
      accessor: 'packageNumber' 
    },
    { 
      Header: autoT('Peso'), 
      accessor: 'weight',
      Cell: ({ value }) => `${formatNumberWithComma(value)} kg`
    },
    {
      Header: autoT('Dimensiones'),
      accessor: 'dimensions'
    },
    {
      Header: autoT('Codigo RFID'),
      accessor: 'RFID'
    },
    {
      Header: autoT('Detalles'),
      id: 'details',
      Cell: ({ row }) => (
        <Button
          icon="detail-view"
          design="Transparent"
          onClick={() => handleOpenDetails(row.original)}
          title={autoT('Ver detalles')}
        />
      )
    },
    ...(asnDetail?.asnStatus === 'Shipped' || asnDetail?.asnStatus === 'Received' ? [{
      Header: '',
      id: 'actions',
      Cell: ({ row }) => (
        <Button
          icon="print"
          design="Transparent"
          onClick={() => handleConfirmPrint(row.original)}
          title={autoT('Imprimir')}
        />
      )
    }] : [])
  ];

  // Función para descargar adjuntos
  const handleDownloadAttachment = async (attachment) => {
    try {
      console.log(autoT('Descargando archivo:'), attachment.attachmentName);
      
      const response = await fetch(attachment.filePath);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      link.download = attachment.attachmentName; // Ahora sí funcionará
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Limpiar el ObjectURL
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error(autoT('Error al descargar el archivo:'), error);
    }
  };
  // Columnas para la tabla de adjuntos
  const attachmentColumns = [
    { 
      Header: autoT('Nombre del Archivo'), 
      accessor: 'attachmentName' 
    },
    { 
      Header: autoT('Tipo'), 
      accessor: 'attachmentType' 
    },
    {
      Header: autoT('Obligatorio'),
      accessor: 'mandatory',
      Cell: ({ value }) => (
        <Text style={{ color: value ? '#d32f2f' : '#388e3c' }}>
          {value ? autoT('Sí') : autoT('No')}
        </Text>
      )
    },
    {
      Header: autoT('Fecha de creación'),
      accessor: 'createdDate',
      Cell: ({ value }) => formatDateTime(value)
    },
    {
      Header: autoT('Acciones'),
      id: 'actions',
      Cell: ({ row }) => (
        <Button
          icon="download"
          design="Transparent"
          onClick={() => handleDownloadAttachment(row.original)}
          title={autoT('Descargar archivo')}
        >
          {autoT('Descargar')}
        </Button>
      )
    }
  ];

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  if (loading) return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      gap: '1rem'
    }}>
      <BusyIndicator active size="Large" />
      <Text style={{ fontSize: '1.2rem' }}>{autoT('Cargando Notificación...')}</Text>
    </div>
  );
  
  if (error) return <div>{autoT('Error:')} {error}</div>;

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh' 
    }}>
      <Navbar toggleSidebar={toggleSidebar} />
      <Breadcrumbs />

      <div style={{ 
        display: 'flex',
        flex: 1,
        marginTop: '48px'
      }}>
        <SideMenu isOpen={isSidebarOpen} />
        
        <div style={{ 
          flex: 1,
          marginLeft: isSidebarOpen ? '250px' : '0',
          transition: 'margin-left 0.3s',
          padding: '20px'
        }}>
          {/* Título y botones */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px',
            paddingLeft: '1rem'
          }}>
            <Title level="H2">
              {autoT('Notificación N°')} {asnDetail?.asnNumber}
            </Title>

            <div style={{ 
              display: 'flex', 
              gap: '1rem'
            }}>
            {/* Botón de Editar */}
            {(asnDetail?.asnStatus === 'Pending' || asnDetail?.asnStatus === 'Modified') && hasPermission('notification', 'update') && (
              <Button 
                onClick={() => navigate(`/edit-asn/${asnDetail?.id}`)}
              >
                {autoT('Editar Notificación')}
              </Button>
            )}
            
            {/* Botón de Ver Seguimiento */}
            {hasPermission('notification', 'listView') && (
              <Button icon="workflow-tasks" onClick={handleShowTracking}>{autoT('Ver Seguimiento')}</Button>
            )}

            {/* Modal de seguimiento */}
            {showTrackingModal && (
              <Dialog
                open={showTrackingModal}
                headerText={autoT('Seguimiento de notificación')}
                footer={
                  <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '0.5rem' }}>
                    <Button onClick={() => setShowTrackingModal(false)}>{autoT('Cerrar')}</Button>
                  </div>
                }
              >
                <div style={trackingStyles.trackingModal}>
                  {trackingInfo.length > 0 ? (
                    <div style={trackingStyles.trackingStepsContainer}>
                      {trackingInfo.map((step, index) => (
                        <div key={index} style={trackingStyles.trackingStep}>
                          {/* Línea vertical */}
                          {index !== trackingInfo.length - 1 && (
                            <div style={trackingStyles.trackingStepBefore}></div>
                          )}
                          {/* Icono */}
                          <div style={trackingStyles.trackingIcon}>
                            {step.action === 'Creada' && <Icon name="add-document" style={{ color: '#0066cc' }} />}
                            {step.action === 'Por Despachar' && <Icon name="pending" style={{ color: '#ffc107' }} />}
                            {step.action === 'Preparando envio' && <Icon name="package" style={{ color: '#ff9800' }} />}
                            {step.action === 'Despachada' && <Icon name="shipping-status" style={{ color: '#0066cc' }} />}
                            {step.action === 'En camino' && <Icon name="truck" style={{ color: '#2196f3' }} />}
                            {step.action === 'Entregado' && <Icon name="delivery" style={{ color: '#4caf50' }} />}
                            {step.action === 'Recepcionada' && <Icon name="activity-2" style={{ color: '#0066cc' }} />}
                            {step.action === 'Finalizada' && <Icon name="accept" style={{ color: '#28a745' }} />}
                            {step.action === 'Modificada' && <Icon name="edit" style={{ color: '#ffc107' }} />}
                            {step.action === 'Anulada' && <Icon name="decline" style={{ color: '#dc3545' }} />}
                            {step.action === 'Devuelto' && <Icon name="return" style={{ color: '#f44336' }} />}
                          </div>
                          {/* Detalles del paso */}
                          <div style={trackingStyles.trackingDetails}>
                            <h4 style={trackingStyles.trackingDetailsH4}>{formatDateTime(step.created_date)}</h4>
                            <p style={{ ...trackingStyles.trackingDetailsP, ...trackingStyles.trackingDetailsAction }}>{step.action}</p>
                            <p style={trackingStyles.trackingDetailsP}>{step.description}</p>
                            {step.created_by && step.created_by.trim() !== '' ? (
                              <p style={trackingStyles.trackingDetailsP}>{autoT('Creado por:')} {step.created_by}</p>
                            ) : step.modified_by && step.modified_by.trim() !== '' ? (
                              <p style={trackingStyles.trackingDetailsP}>{autoT('Modificado por:')} {step.modified_by}</p>
                            ) : null}
                            <p style={trackingStyles.trackingDetailsP}>{step.details}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p style={{ textAlign: 'center', color: '#6b7280' }}>{autoT('No hay información de seguimiento disponible.')}</p>
                  )}
                </div>
              </Dialog>
            )}
            
            {/* Botón para imprimir documento */}
            {(asnDetail?.asnStatus !== 'Pending' && asnDetail?.asnStatus !== 'Modified') && hasPermission('notification', 'listView') && (
              <Button 
                design='Emphasized' 
                icon='print'
                onClick={handleDialogAsnPrint}
              >
                {autoT('Imprimir Documento')}
              </Button>
            )}
            </div>
          </div>
          <ObjectPage
            headerContentPinnable
            titleArea={
              <ObjectPageTitle>
                <ObjectStatus
                  style={getStatusComponentProps(asnDetail?.asnStatus).style}
                >
                  {getStatusLabel(asnDetail?.asnStatus)}
                </ObjectStatus>
              </ObjectPageTitle>
            }
            headerArea={
              <ObjectPageHeader>
                <FlexBox direction="Column">
                  <Label><strong>{autoT('Fecha de entrega:')}</strong> {asnDetail?.deliveryDate}</Label>
                  <Label><strong>{autoT('Orden de notificación:')}</strong> {asnDetail?.createdAt}</Label>
                </FlexBox>
              </ObjectPageHeader>
            }
            style={{
              height: '700px'
            }}
          >
            {/* Sección de Información General */}
            <ObjectPageSection id="general-information" titleText={autoT('Información General')}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {/* Datos Básicos */}
                <div style={{ 
                  backgroundColor: 'white',
                  padding: '1rem',
                  borderRadius: '8px',
                  boxShadow: '0 0 4px rgba(0,0,0,0.1)'
                }}>
                  <Title level="H5" style={{ marginBottom: '1rem' }}>{autoT('Datos Básicos')}</Title>
                  
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    gap: '20px' 
                  }}>
                    {/* Left Column for Existing Basic Data */}
                    <div style={{ flex: '1 1 300px' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        <div>
                          <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Número de notificación:')}</Label>
                          <Text>{asnDetail?.asnNumber}</Text>
                        </div>
                        <div>
                          <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Orden de compra:')}</Label>
                          <FlexBox alignItems="Center" style={{ gap: '0.5rem' }}>
                            <Text>{purchaseOrder?.orderNumber}</Text>
                            {hasPermission('buyorder', 'listView') && (
                              <Icon 
                                name="navigation-right-arrow"
                                onClick={() => navigate(`/order-detail/${purchaseOrder?.orderNumber}`)}
                                style={{ cursor: 'pointer', color: '#0066cc' }}
                              />
                            )}
                          </FlexBox>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '2rem' }}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Estado notificación:')}</Label>
                      <Button 
                        onClick={() => (asnDetail?.asnStatus === 'Shipped' || asnDetail?.asnStatus === 'Pending' || asnDetail?.asnStatus === 'Modified' || asnDetail?.asnStatus === 'In transit' || asnDetail?.asnStatus === 'Delivered') ? setShowStatusDialog(true) : null}
                        disabled={!(asnDetail?.asnStatus === 'Shipped' || asnDetail?.asnStatus === 'Pending' || asnDetail?.asnStatus === 'Modified' || asnDetail?.asnStatus === 'In transit' || asnDetail?.asnStatus === 'Delivered')}
                        style={{
                                marginLeft: '10px',
                          ...getStatusComponentProps(asnDetail?.asnStatus, null, {
                            cursor: (asnDetail?.asnStatus === 'Pending' || asnDetail?.asnStatus === 'Modified' || asnDetail?.asnStatus === 'In transit' || asnDetail?.asnStatus === 'Delivered' || asnDetail?.asnStatus === 'Shipment') ? 'pointer' : 'default',
                            opacity: (asnDetail?.asnStatus === 'Pending' || asnDetail?.asnStatus === 'Modified' || asnDetail?.asnStatus === 'In transit' || asnDetail?.asnStatus === 'Delivered' || asnDetail?.asnStatus === 'Shipment') ? 1 : 0.7
                          }).style
                        }}
                      >
                        {getStatusLabel(asnDetail?.asnStatus)}
                      </Button>
                    </div>
                    </div>
                    <div style={{
                              marginLeft: '0px',
                          ...getStatusStyle(asnDetail?.asnStatus),
                          borderRadius: '4px',
                          padding: '5px',
                          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                        }}>
                        <div style={{ display: 'flex', gap: '2rem' }}>
                          <div style={{ flex: 1 }}>
                            <Label style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                              {autoT('Motivo:')}
                            </Label>
                            <Text style={{ 
                              display: 'block', 
                              marginTop: '0.25rem',
                              color: getStatusStyle(asnDetail?.asnStatus).color,
                              fontSize: '0.9rem'
                            }}>
                              {asnDetail?.description || autoT('No se especificó motivo')}
                            </Text>
                          </div>
                          <div>
                            <Label style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                              {autoT('Evaluado por:')}
                            </Label>
                            <Text style={{ 
                              display: 'block', 
                              marginTop: '0.25rem',
                              color: getStatusStyle(asnDetail?.asnStatus).color,
                              fontSize: '0.9rem'
                            }}>
                              {asnDetail?.modifiedByName || autoT('Usuario no especificado')}
                            </Text>
                          </div>
                          <div>
                            <Label style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                              {autoT('Fecha de evaluacion:')}
                            </Label>
                            <Text style={{ 
                              display: 'block', 
                              marginTop: '0.25rem',
                              color: getStatusStyle(asnDetail?.asnStatus).color,
                              fontSize: '0.9rem'
                            }}>
                              {formatDateToDDMMYYYY(asnDetail?.modifiedDate)}
                            </Text>
                          </div>
                        </div>
                      </div>
                      </div>
                    </div>

                    {/* Right Column for Position and Ramp Assignment Status */}
                    <div style={{ flex: '1 1 300px' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        <div>
                          <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Posición:')}</Label>
                          <Text>{asnDetail?.position || autoT('Posición no marcada')}</Text>
                        </div>
                        <div>
                          <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Estado de Asignación:')}</Label>
                          <Text>
                            {asnDetail?.rampAssignmentStatus === 'ASSIGNED' ? autoT('Asignado') : 
                             asnDetail?.rampAssignmentStatus === 'PENDING' ? autoT('Sin asignado') : 
                             autoT('Sin asignar')}
                          </Text>
                        </div>
                        <div>
                          <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Número de agendamiento')}</Label>
                          <Text>{asnDetail?.scheduleNumber}</Text>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>

                {/* Información de Envío */}
                <div style={{ 
                  backgroundColor: 'white',
                  padding: '1rem',
                  borderRadius: '8px',
                  boxShadow: '0 0 4px rgba(0,0,0,0.1)'
                }}>
                  <Title level="H5" style={{ marginBottom: '1rem' }}>{autoT('Información de envío')}</Title>
                    <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: 'repeat(3, 1fr)', 
                    gap: '1rem' 
                  }}>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Fecha creada de notificación:')}</Label>
                      <Text>{formatDateToDDMMYYYY(asnDetail?.createdDate)}</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Nombre de cliente:')}</Label>
                      <Text>{purchaseOrder?.originName || 'N/A'}</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Dirección de origen:')}</Label>
                      <Text>{purchaseOrder?.originAddress || 'N/A'}</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Guía de despacho:')}</Label>
                      <Text>{asnDetail?.slipNumber || autoT('No hay guía de despacho')}</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Instrucciones de despacho:')}</Label>
                      <Text>{asnDetail?.shipmentInstructions || autoT('No hay instrucciones de despacho')}</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Fecha de entrega:')}</Label>
                      <Text>{formatDateToDDMMYYYY(asnDetail?.deliveryDate)}</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Número de bulto:')}</Label>
                      <Text>{asnDetail?.packageQty || 'N/A'}</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Volumen:')}</Label>
                      <Text>{formatNumberWithComma(asnDetail?.totalVolume || 0)}</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Peso:')}</Label>
                      <Text>{formatNumberWithComma(asnDetail?.totalWeight || 0)} kg</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Tipo de carga:')}</Label>
                      <Text>{asnDetail?.chargeType || 'N/A'}</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Nombre de cliente destino:')}</Label>
                      <Text>{purchaseOrder?.destinationName || 'N/A'}</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Dirección de destino:')}</Label>
                      <Text>{purchaseOrder?.destinationAddress || 'N/A'}</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Tipo de bulto:')}</Label>
                      <Text>{asnDetail?.shipmentType}</Text>
                    </div>
                    <div>
                      <Label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>{autoT('Medio de transporte:')}</Label>
                      <Text>{asnDetail?.transportMedium || 'N/A'}</Text>
                    </div>
                  </div>
                </div>
              </div>
            </ObjectPageSection>

            {/* Sección de Materiales */}
            <ObjectPageSection id="materials" titleText={autoT('Materiales')}>
              <div style={{ 
                backgroundColor: 'white',
                padding: '1rem',
                borderRadius: '8px',
                boxShadow: '0 0 4px rgba(0,0,0,0.1)'
              }}>
                <AnalyticalTable
                  data={asnDetail?.items || []}
                  columns={materialColumns}
                  visibleRows={5}
                  minRows={5}
                  scaleWidthMode="Smart"
                />
              </div>
            </ObjectPageSection>

            {/* Sección de Bultos */}
            <ObjectPageSection id="packages" titleText={autoT('Bultos')}>
              <div style={{ 
                backgroundColor: 'white',
                padding: '1rem',
                borderRadius: '8px',
                boxShadow: '0 0 4px rgba(0,0,0,0.1)'
              }}>
                <AnalyticalTable
                  data={asnDetail?.packages || []}
                  columns={packageColumns}
                  visibleRows={5}
                  minRows={5}
                  scaleWidthMode="Smart"
                />
              </div>
            </ObjectPageSection>

            {/* Sección de Adjuntos */}
            <ObjectPageSection id="attachments" titleText={autoT('Adjuntos')}>
              <div style={{ 
                backgroundColor: 'white',
                padding: '1rem',
                borderRadius: '8px',
                boxShadow: '0 0 4px rgba(0,0,0,0.1)'
              }}>
                {attachments && attachments.length > 0 ? (
                  <AnalyticalTable
                    data={attachments}
                    columns={attachmentColumns}
                    visibleRows={5}
                    minRows={5}
                    scaleWidthMode="Smart"
                  />
                ) : (
                  <div style={{
                    textAlign: 'center',
                    padding: '2rem',
                    color: '#666'
                  }}>
                    <Text>{autoT('Sin Adjuntos')}</Text>
                  </div>
                )}
              </div>
            </ObjectPageSection>
          </ObjectPage>

          <Dialog
  open={dialogOpen}
  headerText={autoT('Detalles del Bulto {{packageNumber}}', { packageNumber: selectedRow?.packageNumber })}
  onAfterClose={() => {
    handleCloseDialog();
    setBultoMateriales([]);
  }}
  style={{ width: '800px' }}
>
  <div style={{ padding: '1rem' }}>
    <AnalyticalTable
      data={bultoMateriales}
      columns={[
        { 
          Header: autoT('Posición PL'), 
          accessor: (row, rowIndex) => rowIndex + 1,
          width: 100 
        },
        { 
          Header: autoT('Código Material'), 
          accessor: 'materialCode',
          width: 150 
        },
        { 
          Header: autoT('Descripción'), 
          accessor: 'description',
          width: 250 
        },
        { 
          Header: autoT('Cantidad'), 
          accessor: 'quantity',
          Cell: ({ value }) => (
            <Text style={rightAlignedNumberStyle()}>{formatNumberWithComma(value)}</Text>
          ),
          width: 100 
        },
        { 
          Header: autoT('Unidad'), 
          accessor: 'unit',
          width: 100 
        }
      ]}
      visibleRows={5}
      minRows={5}
      scaleWidthMode="Smart"
    />
  </div>
  <div style={{ 
    display: 'flex', 
    justifyContent: 'flex-end', 
    padding: '1rem',
    borderTop: '1px solid #ddd' 
  }}>
    <Button onClick={handleCloseDialog}>{autoT('Cerrar')}</Button>
  </div>
</Dialog>

          {/* Modal de Impresión de Bulto */}
          <Dialog
            open={printDialogOpen}
            onAfterClose={() => setPrintDialogOpen(false)}
            headerText={autoT('Detalles de notificación: {{asnNumber}}', { asnNumber: asnDetail?.asnNumber || '' })}
          >
            <div style={{ padding: '20px' }}>
              {selectedRow && (
                <AnalyticalTable
                  data={[selectedRow]}
                  columns={[
                    {
                      Header: autoT('Package Number'),
                      accessor: 'packageNumber',
                    },
                    {
                      Header: autoT('Weight'),
                      accessor: 'weight',
                    },
                    {
                      Header: autoT('ASN Document ID'),
                      accessor: 'asnDocumentId',
                    },
                    {
                      Header: autoT('Volume'),
                      accessor: 'volume',
                    },
                    {
                      Header: autoT('Dimensions'),
                      accessor: 'dimensions',
                    },
                    {
                      Header: '',
                      id: 'actions',
                      Cell: ({ row }) => (
                        <Button
                          icon="print"
                          design="Transparent"
                          style={{ color: 'grey' }}
                          onClick={() => handlePrint(row.original)}
                          title={autoT('Imprimir')}
                        />
                      ),
                    }
                  ]}
                  minRows={1}
                  style={{ width: '100%' }}
                />
              )}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', padding: '10px' }}>
              <Button design="Transparent" onClick={() => setPrintDialogOpen(false)}>
                {autoT('Cancelar')}
              </Button>
            </div>
          </Dialog>
          
          {/* ASN Status Update */}
          {showStatusDialog && (
            <Dialog
              open={showStatusDialog}
              headerText={autoT('Cambiar Estado de notificación')}
              onAfterClose={() => setShowStatusDialog(false)}
            >
              <div style={{ padding: '1rem' }}>
                <Select
                  value={newStatus}
                  onChange={(event) => setNewStatus(event.detail.selectedOption.value)}
                  style={{ width: '100%', marginBottom: '1rem' }}
                >
                  <Option value="" disabled>-- {autoT('Escoja Opción')} --</Option>
                  {optionsToShow.map((opt) => (
                    <Option 
                      key={opt.value} 
                      value={opt.value}
                      disabled={isProviderUser() && opt.value === 'Received'}
                    >
                      {opt.label}
                    </Option>
                  ))}
                </Select>

                  <textarea
                    placeholder={autoT('Motivo')}
                    onChange={(e) => setRejectionReason(e.target.value)}
                    style={{ width: '100%', marginBottom: '1rem', height: '100px' }}
                  />

                <FlexBox justifyContent={FlexBoxJustifyContent.End} style={{ gap: '0.5rem' }}>
                  <Button 
                    design="Transparent" 
                    onClick={() => setShowStatusDialog(false)}
                  >
                    {autoT('Cancelar')}
                  </Button>
                  <Button 
                    onClick={() => {
                      if ((newStatus === 'Canceled' || newStatus === 'Returned') && !rejectionReason) {
                        setErrorMessage(autoT('El motivo no puede estar vacío.'));
                        setShowErrorDialog(true);
                        return;
                      }
                      handleStatusUpdate();
                    }}
                    disabled={!newStatus}
                    style={{
                      backgroundColor: '#343a40',
                      color: '#fff'
                    }}
                  >
                    {autoT('Confirmar')}
                  </Button>
                </FlexBox>
              </div>
            </Dialog>
          )}
        </div>
      </div>
    </div>
  );
};

export default ASNDetail;